import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
    return (
        <>
            <Header />
            <section className="hero-section-about d-flex align-items-center">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 hero-content offset-lg-3 text-center">
                            <span className="portfolio-hero-subtitle">Privacy Policy</span>
                            <div className=" hedding process-underline-flex justify-content-center">
                                <div className="process-underline"></div>
                                <div className="process-underline"></div>
                            </div>
                            <p className="about-title">
                                At Hope Web Solutions, we believe that a strong online presence is the key to unlocking your business’s full potential. Founded with a passion for creativity and technology, we specialize in delivering innovative, customized web solutions that help businesses of all sizes grow and thrive in the digital world.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="terms-section py-5" style={{ background: '#fff', color: '#222' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="terms-content">

                                {/* Introduction */}
                                <div className="terms-block mb-2 p-2" style={{ color: '#222' }}>
                                    <h3 className="fw-bold mb-2" style={{ color: '#111' }}>Introduction</h3>
                                    <p className="mb-0" style={{ color: '#444' }}>
                                        Welcome to Hope Web Solutions! These Terms and Conditions ("Terms") govern your use of our website and services. By accessing or using our site and services, you agree to be bound by these Terms. If you do not agree, please do not use our services.
                                    </p>
                                </div>

                                {/* Section 1 */}
                                <div className="terms-block mb-2 p-2" style={{ color: '#222' }}>
                                    <h3 className="fw-bold mb-2" style={{ color: '#111' }}>1. Services</h3>
                                    <p className="mb-0" style={{ color: '#444' }}>
                                        Hope Web Solutions provides web design, development, digital marketing, and related services as outlined on our website. Specific service details, timelines, and costs will be defined in individual project agreements.
                                    </p>
                                </div>

                                {/* Section 2 */}
                                <div className="terms-block mb-2 p-2" style={{ color: '#222' }}>
                                    <h3 className="fw-bold mb-2" style={{ color: '#111' }}>2. Payment Terms</h3>
                                    <p className="mb-0" style={{ color: '#444' }}>
                                        Clients agree to pay all fees as specified in the project proposal or invoice. Payments are typically divided into milestones, including an initial deposit before work begins. Late payments may result in project delays or suspension of services.
                                    </p>
                                </div>

                                {/* Section 3 */}
                                <div className="terms-block mb-2 p-2" style={{ color: '#222' }}>
                                    <h3 className="fw-bold mb-2" style={{ color: '#111' }}>3. Client Responsibilities</h3>
                                    <p className="mb-0" style={{ color: '#444' }}>
                                        Clients are responsible for providing all necessary content, images, and other materials required to complete the project on time. Clients must also review and approve deliverables promptly to keep projects on schedule.
                                    </p>
                                </div>

                                {/* Section 4 */}
                                <div className="terms-block mb-2 p-2" style={{ color: '#222' }}>
                                    <h3 className="fw-bold mb-2" style={{ color: '#111' }}>4. Intellectual Property</h3>
                                    <p className="mb-0" style={{ color: '#444' }}>
                                        Unless otherwise agreed, all intellectual property created by Hope Web Solutions remains our property until full payment is received. Upon full payment, ownership rights of custom designs and developed assets will be transferred to the client.
                                    </p>
                                </div>

                                {/* Section 5 */}
                                <div className="terms-block mb-2 p-2" style={{ color: '#222' }}>
                                    <h3 className="fw-bold mb-2" style={{ color: '#111' }}>5. Revisions and Changes</h3>
                                    <p className="mb-0" style={{ color: '#444' }}>
                                        We offer a specified number of revisions as part of each project. Additional changes beyond the agreed scope may incur extra charges and extend delivery timelines.
                                    </p>
                                </div>

                                {/* Section 6 */}
                                <div className="terms-block mb-2 p-2" style={{ color: '#222' }}>
                                    <h3 className="fw-bold mb-2" style={{ color: '#111' }}>6. Client Responsibilities</h3>
                                    <p className="mb-0" style={{ color: '#444' }}>
                                        Clients are responsible for providing all necessary content, images, and other materials required to complete the project on time. Clients must also review and approve deliverables promptly to keep projects on schedule.
                                    </p>
                                </div>

                                {/* Section 7 */}
                                <div className="terms-block mb-2 p-2" style={{ color: '#222' }}>
                                    <h3 className="fw-bold mb-2" style={{ color: '#111' }}>7. Client Responsibilities</h3>
                                    <p className="mb-0" style={{ color: '#444' }}>
                                        Clients are responsible for providing all necessary content, images, and other materials required to complete the project on time. Clients must also review and approve deliverables promptly to keep projects on schedule.
                                    </p>
                                </div>

                                {/* Section 8 */}
                                <div className="terms-block mb-2 p-2" style={{ color: '#222' }}>
                                    <h3 className="fw-bold mb-2" style={{ color: '#111' }}>8. Client Responsibilities</h3>
                                    <p className="mb-0" style={{ color: '#444' }}>
                                        Clients are responsible for providing all necessary content, images, and other materials required to complete the project on time. Clients must also review and approve deliverables promptly to keep projects on schedule.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;
